module.exports = __webpack_public_path__ + "static/media/lean_body_mass.1ed37148.svg";